export const REGION_OPTIONS_CONFIG = [
  // { value: 'global', text: formatMessage({ id: 'dbi_region_segment_global' }) },
  // { value: 'na', text: formatMessage({ id: 'dbi_region_segment_na' }) },
  // { value: 'chn', text: formatMessage({ id: 'dbi_region_segment_chn' }) },
  // { value: 'asia', text: formatMessage({ id: 'dbi_region_segment_asia' }) },
  // { value: 'we', text: formatMessage({ id: 'dbi_region_segment_we' }) },
  // { value: 'ee', text: formatMessage({ id: 'dbi_region_segment_ee' }) },
  // { value: 'others', text: formatMessage({ id: 'dbi_region_segment_others' }) },
  {
    value: 'global',
    text: 'Global',
    label: 'Global',
    text_en: 'Global',
    text_cn: '全球',
  },
  {
    value: 'global_wo_china',
    text: 'Global except China Mainland',
    label: 'Global except China Mainland',
    text_en: 'Global except China Mainland',
    text_cn: '全球（不包括中国大陆）',
  },
  {
    value: 'na',
    text: 'US & Canada',
    label: 'US & Canada',
    text_en: 'US & Canada',
    text_cn: '美国&加拿大',
  },
  {
    value: 'chn',
    text: 'China',
    label: 'China',
    text_en: 'China',
    text_cn: '中国',
  },
  {
    value: 'jp&kr',
    text: 'Japan & Korea',
    label: 'Japan & Korea',
    text_en: 'Japan & Korea',
    text_cn: '日本&韩国',
  },
  {
    value: 'asia',
    text: 'Other Asian Countries',
    label: 'Other Asian Countries',
    text_en: 'Other Asian Countries',
    text_cn: '亚洲其他国家',
  },
  {
    value: 'we',
    text: 'Western Europe',
    label: 'Western Europe',
    text_en: 'Western Europe',
    text_cn: '西欧',
  },
  {
    value: 'ee',
    text: 'Eastern Europe',
    label: 'Eastern Europe',
    text_en: 'Eastern Europe',
    text_cn: '东欧',
  },
  {
    value: 'others',
    text: 'Others',
    label: 'Others',
    text_en: 'Others',
    text_cn: '其他',
  },
];
